/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Component } from "react";
import RenderChart from '../charts/RenderChart'

import widgetConfig from '../../common/widgetConfigs';
import { convertToStackedDataForamat, arrayNameSort, sortDesc, sortAsc, convertToBarDataForamat, getChartHeight } from '../../common/utils';
import EdwSwitchButton from '../common/edwSwitchButton/EdwSwitchButton';
import style from '../../styles.module.scss';
import tableconfig from '../../common/widgetConfigs/performanceByQuestion'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import asyncCallHandler from '../../common/utils/asyncCallHandler'
import EDW_CONST from '../../common/constants';
import { EdwLoaderWithContainer } from '../common/edwLoaderWithContainer/EdwLoaderWithContainer'
import { EDWDropDown } from "../common/dropDown/DropDown";
import { ErrorData } from "../common/noData/NoData";

export class PerformanceByQuestion extends Component {
    constructor(props) {
        super();
        this.state = {
            chartConfig: widgetConfig.barChart,
            isDataLoaded: false,
            showChart: true,
            sortValue: 'question',
            performanceData: [],
            coloumnDef: tableconfig.tableColumnDefinition,
            tableIcons: tableconfig.icons,
            isDataFetch: false,
            IsApiFail:false
        }
        this.iesToken = props.token ? props.token : ''
    }

    componentDidMount() {
        let { assessmentId, groupId, schoolId, dateTaken, studentYear } = this.props;
        this.setState({ isDataFetch: false })
        asyncCallHandler(EDW_CONST.ASSESSMENT_END_POINT, `questionPerformanceData?assessmentId=${assessmentId}&groupId=${groupId}&examDate=${dateTaken}&schoolId=${schoolId}&studentYear=${studentYear}`, this.iesToken).then(response => {
            this.setState({ performanceData: response.data });
            let chartConfigs = this.getChartProps(this.state.sortValue);
            let height = 100 + (parseInt(response.data.length)*50);
            this.setState({ chartConfig: chartConfigs, isDataFetch: true, height: height });
        }).catch((error) => {
            this.setState({ performanceData: [] ,IsApiFail:true});
            console.log("axios error:", error);
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.groupId !== prevProps.groupId ||
            this.props.studentYear !== prevProps.studentYear
        ) {
            let { assessmentId, groupId, schoolId, dateTaken, studentYear } = this.props;
            this.setState({ isDataFetch: false })
            asyncCallHandler(EDW_CONST.ASSESSMENT_END_POINT, `questionPerformanceData?assessmentId=${assessmentId}&groupId=${groupId}&examDate=${dateTaken}&schoolId=${schoolId}&studentYear=${studentYear}`, this.iesToken).then(response => {
                this.setState({ performanceData: response.data });
                let chartConfigs = this.getChartProps(this.state.sortValue);
                this.setState({ chartConfig: chartConfigs, isDataFetch: true });

            }).catch((error) => {
                this.setState({ performanceData: [] });
                console.log("axios error:", error);
            });
        }
    }

    sortChart = (value) => {
        let chartConfigs = this.getChartProps(value);
        this.setState({ chartConfig: chartConfigs, sortValue: value })

    }

    getChartProps = (sortValue) => {

        let questionData = convertToBarDataForamat(this.state.performanceData, sortValue);

        let chartConfigs = Object.assign({}, this.state.chartConfig);
        let { width, height, token, categories, dataset } = this.props;

        chartConfigs.width = width;
        chartConfigs.height = getChartHeight(this.state.performanceData);

        chartConfigs.dataSource.chart.xAxisname = this.props.xAxisname ? this.props.xAxisname : 'Questions'
        chartConfigs.dataSource.chart.yAxisName = this.props.yAxisName ? this.props.yAxisName : 'Group average (%)'
        chartConfigs.dataSource.data = questionData;
        this.props.updateExportData({ type: "quesiton_widget_1", rowData: this.state.performanceData, columnDefs: this.state.coloumnDef });  

        return chartConfigs;
    }
    switchView = (e) => {
        this.setState({ showChart: e.target.checked })
        let chartConfigs = Object.assign({}, this.state.chartConfig);
        if (e.target.checked) {
            chartConfigs = this.getChartProps(this.state.sortValue);
        }
        this.setState({ chartConfig: chartConfigs });
    }
    getTableView = () => {
        return <div className="ag-theme-alpine" style={{
            height: this.state.height, width: '920px', margin: '0 auto', padding: '0px',
            position: 'relative'
        }} >
            <AgGridReact tooltipShowDelay={0}
                columnDefs={this.state.coloumnDef}
                rowData={this.state.performanceData}
                icons={this.state.tableIcons}
                onSortChanged={this.onSortChanged.bind(this)}
            />

        </div>
    }
   
    getChartBlock = () => {

        if (!this.state.isDataFetch && !this.state.IsApiFail)
            return <EdwLoaderWithContainer />
        else if (this.state.isDataFetch && this.state.performanceData.length > 0 && !this.state.IsApiFail) {
            return <div className="chartCls">
                <RenderChart chartConfigs={this.state.chartConfig} fusionKey={this.props.fusionKey}/>
            </div>
        }
        else
            return <ErrorData />

    }
    sort_by_key = (array, key) => {
        return array.sort(function (a, b) {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }
    onSortChanged = (params) => {
        let sortModel = params.api.getSortModel();
        let sortedRowData = this.sort_by_key(this.state.performanceData, sortModel[0]["colId"]);
        this.setState({ performanceData: sortedRowData });
    }

    render() {
        let switchProps = {
            leftLable: EDW_CONST.TABLE_VIEW,
            rightLable: EDW_CONST.GRAPH_VIEW,
            checked: this.state.showChart,
            handleChange: this.switchView
        }
        return (
            < div >
                <div className="col">
                    <div className="row">
                        <div className="col-md-8 chartTitle">
                            <label><span className="card-title">Performance by question</span></label>
                        </div>
                    </div>
                    {(this.state.isDataFetch && this.state.performanceData.length > 0) &&
                        <div className="row content-row-padding">
                            <div style={{ flex: 1, marginRight: 20 }}></div>
                            <div style={{ marginRight: 20 }}>
                                <label className={style.lblColor}>Order of questions</label>
                                <EDWDropDown
                                    items={[
                                        { id: 'question', label: 'Question order', },
                                        { id: 'asc', label: 'Lowest to highest performance', },
                                        { id: 'desc', label: 'Highest to lowest performance', },
                                    ]}
                                    onChange={this.sortChart}
                                    label="Order of questions"
                                    value={this.state.sortValue}
                                />
                            </div>
                            <div> <div className="edw-switch-btn-adj">
                                <EdwSwitchButton {...switchProps} />

                            </div>
                            </div>

                        </div>
                    }
                </div>
                {this.state.showChart && <div className="edw-full-width">
                    {this.getChartBlock()}
                </div>
                }
                {!this.state.showChart && <div className="center-align">
                    {this.state.isDataFetch ? (this.getTableView()) : ''}
                </div>
                }
            </div>

        );
    }
}


